// Driver invites API client — Phase 2 Plan 02-05 Task 2.
//
// POST /api/v1/driver-invites — create single-use invite (QR + short_code).
// GET  /api/v1/driver-invites/{id}/status — poll status (Mini App polling).
//
// Mirrors api/companies.ts pattern.

import type { ApiClient } from "./client";

export interface DriverInviteCreate {
  driver_name_hint?: string | null;
  expires_in_hours?: number;
}

export interface DriverInviteResponse {
  invite_id: number;
  qr_png_base64: string;
  short_code: string;
  deep_link: string;
  expires_at: string; // ISO 8601 UTC
}

export type DriverInviteStatus = "pending" | "used" | "revoked" | "expired";

export interface DriverInviteStatusResponse {
  invite_id: number;
  status: DriverInviteStatus;
  used_at: string | null;
  used_by_telegram_id: number | null;
}

export async function createDriverInvite(
  client: ApiClient,
  payload: DriverInviteCreate = {},
): Promise<DriverInviteResponse> {
  // Drop undefined/empty optional fields — server applies defaults.
  const cleaned: Record<string, unknown> = {};
  if (payload.driver_name_hint?.trim()) {
    cleaned.driver_name_hint = payload.driver_name_hint.trim();
  }
  if (typeof payload.expires_in_hours === "number") {
    cleaned.expires_in_hours = payload.expires_in_hours;
  }
  return client.post<DriverInviteResponse>("/api/v1/driver-invites", cleaned);
}

export async function getInviteStatus(
  client: ApiClient,
  inviteId: number,
): Promise<DriverInviteStatusResponse> {
  return client.get<DriverInviteStatusResponse>(`/api/v1/driver-invites/${inviteId}/status`);
}
